import {
  animate,
  AUTO_STYLE,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

const DEFAULT_DURATION = 300;

@Component({
  selector: 'app-footer',
  imports: [TranslateModule, RouterLink, RouterLinkActive],
  standalone: true,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out')),
    ]),
  ],
})
export class FooterComponent {
  mobileFoot = true;
  mobileContact = true;

  toggleMenu() {
    this.mobileFoot = !this.mobileFoot;
  }

  toggleContact() {
    this.mobileContact = !this.mobileContact;
  }
}
